import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getCategoryOptions } from './Categories';
import { useStrategy } from '../../../hooks/useStrategy';
import { Box } from 'foundations-components/transitional/components/Box';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
const CategorySelect = ({
  value,
  onChange
}) => {
  const {
    getFilterFamilyOptions
  } = useStrategy();
  const filterFamilyOptions = getFilterFamilyOptions();
  const categories = getCategoryOptions();
  const enabledCategories = categories.filter(category => filterFamilyOptions.find(option => option.category === category.id));
  if (enabledCategories.length <= 1) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    gap: "200",
    paddingBlockStart: "400",
    marginInline: "400",
    children: enabledCategories.map(option => /*#__PURE__*/_jsx(Box, {
      basis: `${100 / enabledCategories.length}%`,
      children: /*#__PURE__*/_jsx(Button, {
        active: value === option.id,
        block: true,
        onClick: () => onChange(option.id),
        size: "extra-small",
        use: "tertiary-extra-light",
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: option.messageKey
          })
        })
      })
    }, option.id))
  });
};
export default CategorySelect;